import React, { createContext, ReactNode, useContext, useState } from 'react';

type loadingContextData = {
  loading: boolean;
  changeLoadingStatus: (status: boolean) => void;
};

type LoadingProviderProps = {
  children: ReactNode;
};

export const LoadingContext = createContext<loadingContextData>(
  {} as loadingContextData
);
function LoadingProvider({ children }: LoadingProviderProps) {
  const [loading, setLoading] = useState(false);

  function changeLoadingStatus(status: boolean) {
    setLoading(status);
  }

  return (
    <LoadingContext.Provider
      value={{
        loading,
        changeLoadingStatus,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
}

function useLoading() {
  const context = useContext(LoadingContext);

  return context;
}

export { LoadingProvider, useLoading };
